import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return [
      "expiryOptionsField",
      "expiryReminderBeginsContainer",
      "expiryReminderBeginsField",
      "expiryReminderIntervalContainer",
      "expiryReminderIntervalField",
      "adminExpiryRemindersContainer",
      "adminExpiryRemindersField"
    ];
  }

  connect() {
    this.checkVisibility();
  }

  checkVisibility() {
    if (this.expiryOptionsFieldTarget.value === "not_required") {
      this.expiryReminderBeginsContainerInitialDisplay = hideElement(this.expiryReminderBeginsContainerTarget);
      this.expiryReminderIntervalContainerInitialDisplay = hideElement(this.expiryReminderIntervalContainerTarget);
      this.adminExpiryRemindersContainerInitialDisplay = hideElement(this.adminExpiryRemindersContainerTarget);
      disableElement(this.expiryReminderBeginsFieldTarget);
      disableElement(this.expiryReminderIntervalFieldTarget);
      disableElement(this.adminExpiryRemindersFieldTarget);
    } else {
      showElement(this.expiryReminderBeginsContainerTarget, this.expiryReminderBeginsContainerInitialDisplay);
      showElement(this.expiryReminderIntervalContainerTarget, this.expiryReminderIntervalContainerInitialDisplay);
      showElement(this.adminExpiryRemindersContainerTarget, this.adminExpiryRemindersContainerInitialDisplay);
      enableElement(this.expiryReminderBeginsFieldTarget);
      enableElement(this.expiryReminderIntervalFieldTarget);
      enableElement(this.adminExpiryRemindersFieldTarget);
    }
  }
}
